/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/estudiante'

export default {
    get: params => {
        let customRoute = `${route}?expand=sexo,countcursos,status_description&search=${params.filter}`
        switch (params.estudianteEstado) {
            case "2": customRoute = `${route}?estado=1&expand=sexo,countcursos,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&expand=sexo,countcursos,status_description&search=${params.filter}`
                break;
            case "4": customRoute = `${route}?estado=2&expand=sexo,countcursos,status_description&search=${params.filter}`
                break;
            case "5": customRoute = `${route}?${params.customfilter}&expand=sexo,countcursos,status_description&search=${params.filter}`//altas del dia
                break;
            case "6": customRoute = `${route}?${params.customfilter}&expand=sexo,countcursos,status_description&search=${params.filter}`
                break;
            default: break;
        }//ToDo: revisar los parametros cuando se separen el estado del softdelete y el de pago
        return Api().get(customRoute, { params, crossDomain: true })
    },
    loadDetails: payload => Api().get(`${route}/${payload.id}?expand=sexo,padre,madre,tipo_sangre,servicio_medico,countcursos,status_description,image`, { crossDomain: true }),
    getEstudianteDetails: (payload) => Api().get(`${route}/${payload.id}?expand=status_description`, { crossDomain: true }), //para obtener los datos desde el curso
    getAllRecords: () => Api().get(`${route}?fields=id,nombre,apellido_paterno,apellido_materno&expand=status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=countcursos,status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=countcursos,status_description`, payload),
    put: payload => Api().post(`${route}/${payload.get('id')}?expand=sexo,padre,madre,tipo_sangre,servicio_medico,countcursos,status_description,image`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}&expand=countcursos,status_description`),
    uploadPagos: payload => Api().post(`${route}/cargar-pagos`, payload), //cargando el archivo de pagos
    downloadModeloPago: (payload) => Api().get(`${route}/download-modelo-pago/${payload.id}`, {responseType: 'blob'}), //descargar modelo de pago
}
